import { Injectable } from "@angular/core"
import { BehaviorSubject } from "rxjs"
import { BusinessData } from "../meta/BusinessData.interface"
import { INITIAL_BUSINESS_DATA } from "../meta/initial-business-data.const"

@Injectable({
  providedIn: "root"
})
export class BusinessDataService {
  private readonly _businessData$ = new BehaviorSubject<BusinessData>(INITIAL_BUSINESS_DATA)
  public readonly businessData$ = this._businessData$.asObservable()

  public getBusinessData(): BusinessData {
    return this._businessData$.getValue()
  }

  public setBusinessData(businessData: Partial<BusinessData>): void {
    this._businessData$.next({
      ...this._businessData$.getValue(),
      ...businessData
    })
  }

}
